<div class="col-md-5 col-centered">
  <h1>Новый тариф</h1>
  <loader-tariff-form [tariff]="tariff" (onSubmit)="onSubmit()"></loader-tariff-form>
</div>
